/**
  * 浅色系饼图
  * @param pieTitle 可不传饼图标题
  * @param dataArr [{name:'',value:0}]数据合集
*/
import { dealBigNum } from "@/assets/js/utils";
export function setOption(paramObj) {
  let option = {
    color: EchartsLightColor,
    title: {
      show: paramObj.pieTitle ?? false,
      text: paramObj.pieTitle,
      left: "left",
    },
    tooltip: {
      trigger: "item",
    },
    legend: {
      type: "scroll",
      bottom: "bottom",
      itemHeight: 5,
      itemWidth: 5,
    },
    series: [
      {
        type: "pie",
        radius: "60%",
        data: paramObj.dataArr,
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: "rgba(0, 0, 0, 0.5)",
          },
        },
        label: {
          formatter: (params) => {
            return (
              params.name +
              (params.percent == undefined ? 0 : params.percent) +
              "%\n{value|" +
              dealBigNum(params.value) +
              "}"
            );
          },
          rich: {
            icon: {
              fontSize: 12,
              color: "inherit",
            },
            name: {
              fontSize: 12,
              padding: [0, 0, 0, 10],
              color: "#000",
            },
            value: {
              fontSize: 12,
              fontWeight: "bolder",
              padding: [3, 0, 0, 0],
              color: "inherit",
            },
          },
        },
      },
    ],
  };
  

  return option
  
}